import { render, staticRenderFns } from "./pro-chiose-tab-departmemt.vue?vue&type=template&id=0cdf7616&scoped=true";
import script from "./pro-chiose-tab-departmemt.vue?vue&type=script&lang=jsx";
export * from "./pro-chiose-tab-departmemt.vue?vue&type=script&lang=jsx";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "0cdf7616", null);
export default component.exports;